import { blobClient } from '@api/client';
import { URL } from '@api/urls';

import { IExportAllCellsDTO, IExportCellsDTO } from '@interfaces/cells/dto/cellsDTO';

const {
	exportAllCells,
	exportAllCellsLimenet,
	sites,
	export4GFddCells,
	export4GTddCells,
	export5GCells,
} = URL;

export const exportAllSites = (data: IExportAllCellsDTO): Promise<void> => {
	return blobClient({
		method: 'post',
		url: `${sites}/${exportAllCells}`,
		params: data,
	});
};

export const exportAllSitesLimenet = (data: IExportAllCellsDTO): Promise<void> => {
	return blobClient({
		method: 'post',
		url: `${sites}/${exportAllCellsLimenet}`,
		params: data,
	});
};

export const exportCells4GTdd = (dto: IExportCellsDTO): Promise<void> => {
	return blobClient.post(`${sites}/${dto.vendor.toLowerCase()}/${export4GTddCells}`, dto);
};

export const exportCells4GFdd = (dto: IExportCellsDTO): Promise<void> => {
	return blobClient.post(`${sites}/${dto.vendor.toLowerCase()}/${export4GFddCells}`, dto);
};

export const exportCells5G = (dto: IExportCellsDTO): Promise<void> => {
	return blobClient.post(`${sites}/${dto.vendor.toLowerCase()}/${export5GCells}`, dto);
};
